// We need to use the allowComputed option here because we are importing icons as namespace
/* eslint import/namespace: ['error', { allowComputed: true }] */
import { icons } from "@oysterhr/icons"
import classNames from "classnames"
import { forwardRef } from "react"
import type { IconProps, IconSizes } from "./types"

const SIZE_TO_NUMBER: Record<IconSizes, number> = {
  xs: 16,
  sm: 24,
  md: 32,
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ name, size = "xs", className, ...rest }, ref) => {
    const ImportedIcon = icons[name]
    if (!ImportedIcon) {
      throw new Error(
        `No icon found for ${name}. Please see https://storybook.oysterhr.com/?path=/story/design-system-icon--list`,
      )
    }

    const sizeToNumber = SIZE_TO_NUMBER[size]

    return (
      <ImportedIcon
        role="img"
        data-icon={name}
        width={sizeToNumber}
        height={sizeToNumber}
        ref={ref}
        className={classNames("inline-block", className)}
        {...rest}
      />
    )
  },
)
